module.exports = __webpack_public_path__ + "static/media/jilongshan_plant.fad14892.webp";